
const router = [
  {
    name: 'material',
    path: '/material',
    icon: 'shezhi',
    component: () => import('/@/views/material/Index.vue'),
    meta: {
      title: '素材管理',
      icon: 'shezhi'
    }
  }
]
export default router
